import { createSlice } from "@reduxjs/toolkit";
import { fetchStores } from "./operations";
import { handlePending, handleReject, handleStoresFulfilled } from "./actions";

const initialState = {
  stores: [],
  isLoading: false,
  error: null,
};

const stores = createSlice({
  name: "stores",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchStores.pending, handlePending)
      .addCase(fetchStores.fulfilled, handleStoresFulfilled)
      .addCase(fetchStores.rejected, handleReject);
  },
});

export const storesReducer = stores.reducer;
